import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.css";
import "./i18n";
import i18n from "./i18n";
import perkthime from "./perkthime";
import { I18nextProvider } from "react-i18next";
import "./firebaseReshaper";
import { getData } from "./firebaseReshaper";
console.log("here");
getData()
  .then(data => {
    ReactDOM.render(
      <I18nextProvider i18n={i18n({ en: data.translations })}>
        <App />
      </I18nextProvider>,
      document.getElementById("root")
    );
  })
  .catch(error => {
    ReactDOM.render(
      <I18nextProvider i18n={i18n(perkthime())}>
        <App />
      </I18nextProvider>,
      document.getElementById("root")
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
